export default {
  quote: {
    subtitle: "Restaurant Registration",
    title1: "Get Started with",
    title2: "MAHAL",
    desc: "Register your restaurant to start sourcing from verified suppliers.",

    fullName: "Full Name",
    companyName: "Company Name",
    selectCountry: "Select Country",
    selectCity: "Select City",
    restaurant: "Restaurant Name",
    email: "Email Address",
    phone: "Phone Number",

    uae: "UAE",
    india: "India",
    saudi: "Saudi Arabia",

    dubai: "Dubai",
    abudhabi: "Abu Dhabi",
    sharjah: "Sharjah",

    restA: "Restaurant A",
    restB: "Restaurant B",

    cta: "Continue →",
  },
};